<template>
  <div class="nav-bar">
    <div class="nav-main">
      <!-- 左边 logo -->
      <div class="nav-bar-left">
        <div class="logo">
          <el-link :underline="false">
            <img src="~/@/assets/img/topNav/logo.png" alt="">
          </el-link>
        </div>
      </div>
      <!-- 中间 -->
      <div class="nav-bar-middle">
        <el-menu v-if="!isRefresh" @select='selectBtn' :currentNav='setIndexFn' text-color='#000'
          active-text-color='#fff' :router='false' :default-active='showIndex' class="el-menu-demo" mode="horizontal">
          <el-menu-item ref="navItem" v-for="(item,index) of navList" :key="index" :index="item.path">
            {{item.title}}
          </el-menu-item>
        </el-menu>
      </div>

      <!-- 右边 -->
      <div class="nav-bar-right">

        <div v-if="!isLogin" class="user-login">
          <el-link @click="goLogin" :underline="false">登录</el-link>
          <div class="user-login-line"></div>
          <el-link @click='goRegister' :underline="false">注册</el-link>
        </div>

        <div v-if="isLogin" class="user-login">
          <!-- 头像 -->
          <div @click="goProfile" class="block">
            <el-avatar :size="20" :src="circleUrl"></el-avatar>
          </div>

          <!-- 通知消息 -->
          <div class="message">
            <span v-show="msgList.length!=0" class="msg_num">{{msgList.length}}</span>

            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>通知消息</span>
                <el-button style="float: right; padding: 3px 0; color: #24ba58;" type="text">清空
                </el-button>
              </div>

              <div class="infinite-list" v-infinite-scroll="load">
                <div class="infinite-list-item" v-for="(item,i) in msgList" :key="i" @click="goVideoPage('10000059')">
                  {{item.say}}
                </div>
              </div>
            </el-card>
          </div>

          <!-- 退出登录 -->
          <div @click="exitLogin" class="exitLogin">
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/util/index";
import {
  qqCallback,
  ddCallback,
  wxCallback,
  getAllAdvice,
  delAllAdvice,
  logout,
  bindingAPP,
} from "@/network/loginRequest/api";
import { connectMQ } from "@/util/RabbitMQ";

import { mapState } from "vuex";

export default {
  name: "TopNav",
  data() {
    return {
      //顶部导航栏--------------------------------------------
      navList: [
        // { title: "首页" },
        { title: "资源中心", path: "/resource-center" },
        { title: "题库中心", path: "/question-bank" },
        { title: "卷库中心", path: "/paper-center" },
        // { title: "云课中心", path: "/cloud-class" },
        { title: "图书中心", path: "/e-book" },
        // { title: "应用中心", path: "/app-center" },
        // { title: "仿真实验", path: "simulation" },
        // { title: "电教资源", path: "dhe" },
        { title: "安道教育", path: "amdox" },
      ],
      //头像--------------------------------------------
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      //消息列表--------------------------------------------
      msgList: [],
      //是否刷新el-menu
      isRefresh: false,
    };
  },

  computed: {
    ...mapState({
      isLogin: "isLogin",
      showIndex: "showIndex",
    }),

    //计算顶部导航active
    setIndexFn() {
      let flag = "";
      this.$route.matched[0] && (flag = this.$route.matched[0].path);
      this.$store.commit("setIndex", flag);
    },
  },

  created() {
    this.$bus.exitLogin = this.exitLogin;

    //第三方绑定和登录初始化
    this.thirdPartyInit();
  },

  methods: {
    //新开窗口
    selectBtn(e) {
      switch (e) {
        case "simulation":
          //刷新导航中间组件--------------------------------------------
          this.isRefresh = true;
          setTimeout(() => {
            this.isRefresh = false;
          }, 0);
          open("http://www.rainiersoft.cn/rewrite/login_page");
          break;

        case "dhe":
          //刷新导航中间组件--------------------------------------------
          this.isRefresh = true;
          setTimeout(() => {
            this.isRefresh = false;
          }, 0);
          open("http://dhedu.amdox.com.cn/");
          break;

        case "amdox":
          //刷新组件--------------------------------------------
          this.isRefresh = true;
          setTimeout(() => {
            this.isRefresh = false;
          }, 0);
          open("http://amdox.com/zh/home");
          break;

        default:
          this.$router.push(e);
          break;
      }
    },

    //跳转播放页面
    goVideoPage(cloudClassId) {
      this.$router.push({
        name: "VideoPage",
        query: { cloudClassId: cloudClassId },
      });
    },

    //跳登录
    goLogin() {
      this.$router.push({ path: "/login" });
    },
    //跳注册
    goRegister() {
      this.$router.push({ path: "/login", query: { showName: "2" } });
    },

    //跳我的页面
    goProfile() {
      this.$router.push({ path: "/profile" });
    },

    //滚动加载
    load() {},

    //退出登录
    exitLogin() {
      logout().then((res) => {});
      utils.removeSess("store");
      utils.removeSess("loginMessage");
      utils.removeSess("Authorazition");
      // sessionStorage.clear(); //清除当前浏览器所以Session
      utils.clearCookie("loginMessage");
      utils.clearCookie("userId");
      utils.clearCookie("Authorazition");
      utils.clearAmdoxCookie("token");
      this.$store.commit("isLogin", false);
      this.$store.commit("setUser", "");
      this.$store.commit("setUserId", "");
      this.$router.push("/resource-center");
    },

    //第三方绑定和登录
    thirdPartyInit() {
      let searchObj = utils.getUrlSearch(window.location.search);

      //微信--------------------------------------------
      if (!searchObj.hasOwnProperty("code")) {
        searchObj = utils.getUrlSearch(
          window.location.hash.split("#/resource-center/cloud-resource")[1]
        );
      }

      //判断是否是第三方绑定或者登录
      if (
        (searchObj.code && searchObj.state) ||
        sessionStorage.getItem("otherKey")
      ) {
        //判断是否刷新过页面
        if (sessionStorage.getItem("otherKey")) {
          //第三方
          let obj = utils.getUrlSearch(sessionStorage.getItem("otherKey"));
          sessionStorage.removeItem("otherKey");

          //第三方绑定
          if (this.$store.state.userId) {
            let fd = new FormData();
            fd.append("code", obj.code);
            fd.append("password", "");
            fd.append("state", "");
            fd.append("telephone", "");

            //微信
            if (utils.getSess("wxBind") == 1) {
              this.goProfile();
              utils.removeSess("wxBind");
              fd.append("type", "wx");
              bindingAPP(fd).then((res) => {
                console.log("created -> res", res);
                if (res.data.success) {
                  utils.tips("success", "绑定成功");
                } else {
                  utils.tips("error", res.data.code);
                }
              });
            }

            //qq
            if (utils.getSess("qqBind") == 2) {
              this.goProfile();
              utils.removeSess("qqBind");
              fd.append("type", "qq");
              bindingAPP(fd).then((res) => {
                console.log("thirdPartyInit -> res", res);
                if (res.data.success) {
                  utils.tips("success", "绑定成功");
                } else {
                  utils.tips("error", res.data.code);
                }
              });
            }

            //钉钉
            if (utils.getSess("ddBind") == 3) {
              this.goProfile();
              utils.removeSess("ddBind");
              fd.append("type", "eapp");
              bindingAPP(fd).then((res) => {
                if (res.data.success) {
                  utils.tips("success", "绑定成功");
                } else {
                  utils.tips("error", res.data.code);
                }
              });
            }
          }

          //第三方登录
          if (!this.$store.state.isLogin) {
            if (utils.getSess("loginType") == 1) {
              //微信
              utils.removeSess("loginType");
              wxCallback(obj).then((res) => {
                console.log("thirdPartyInit -> res", res);
                if (res.data.success) {
                  this.$store.commit("isLogin", true);
                  this.$store.commit("setUserId", res.data.data.userId);
                  //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
                  utils.setSess("store", JSON.stringify(this.$store.state));
                  //保存token到sessionStorage
                  utils.setSess("loginMessage", res.data.data.token);
                  //将验证保存到sessionStorage
                  utils.setSess("Authorazition", res.headers.authorazition);
                } else {
                  utils.tips("error", res.data.code);
                }
              });
            }

            if (utils.getSess("loginType") == 2) {
              utils.removeSess("loginType");
              //qq第三方登录
              qqCallback(obj).then((res) => {
                console.log("thirdPartyInit -> res", res);
                if (res.data.success) {
                  this.$store.commit("isLogin", true);
                  this.$store.commit("setUserId", res.data.data.userId);
                  //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
                  utils.setSess("store", JSON.stringify(this.$store.state));
                  //保存token到sessionStorage
                  utils.setSess("loginMessage", res.data.data.token);
                  //将验证保存到sessionStorage
                  utils.setSess("Authorazition", res.headers.authorazition);
                } else {
                  utils.tips("error", res.data.code);
                }
              });
            }

            if (utils.getSess("loginType") == 3) {
              utils.removeSess("loginType");
              //钉钉第三方登录
              ddCallback(obj).then((res) => {
                console.log("thirdPartyInit -> res", res);
                if (res.data.success) {
                  this.$store.commit("isLogin", true);
                  this.$store.commit("setUserId", res.data.data.userId);
                  //把vuex保存在浏览器 防止用户刷新页面时vuex数据重置
                  utils.setSess("store", JSON.stringify(this.$store.state));
                  //保存token到sessionStorage
                  utils.setSess("loginMessage", res.data.data.token);
                  //将验证保存到sessionStorage
                  utils.setSess("Authorazition", res.headers.authorazition);
                } else {
                  utils.tips("error", res.data.errmsg);
                }
              });
            }
          }
        } else {
          //qq的绑定和登录
          if (!window.location.search) {
            //储存
            sessionStorage.setItem(
              "otherKey",
              window.location.hash.split("#/resource-center/cloud-resource")[1]
            );
            //刷新页面
            let newUrl = window.location.origin + "/" + window.location.hash;
            location.reload();
          } else {
            //非qq绑定和登录
            //刷新前储存search
            sessionStorage.setItem("otherKey", window.location.search);
            //刷新页面
            let newUrl = window.location.origin + "/" + window.location.hash;
            window.location.href = newUrl;
          }
        }
      }
    },
  },
};
</script>

<style lang='less' scoped>
//导航栏背景颜色
@navBarBgc: #fff;
//导航栏高度
@navBarHeight: 60px;

//选择按钮未激活时背景颜色
@navBtnBgc: #fff;
//选择按钮未激活时文字颜色
@navBtnColor: #333;
//选择按钮激活背景
@activeBgc: #24ba58;
//选择按钮激活文字颜色
@activeColor: #fff;

.nav-bar {
  position: fixed;
  z-index: 9999;

  width: 100%;
  height: @navBarHeight;
  background-color: @navBarBgc;
  box-shadow: 0 0 10px #ccc;
}

.nav-main {
  display: flex;
  margin: 0 auto;
  width: 1200px;
  height: @navBarHeight;
  justify-content: space-between;
  .nav-bar-left {
    display: flex;
    margin-right: 40px;
    align-items: center;
  }

  // 中间····························
  .nav-bar-middle {
    display: flex;

    flex: 1;
    justify-content: space-between;
    .el-menu.el-menu--horizontal {
      border-bottom: none;
    }

    /deep/ .el-menu--horizontal > .el-menu-item {
      border-bottom: none;
      color: @navBtnColor!important;
      background-color: @navBtnBgc;
    }

    /deep/ .el-menu--horizontal > .el-menu-item {
      height: @navBarHeight;
      line-height: @navBarHeight;
    }

    /deep/ .el-menu-item.is-active {
      border-bottom: none;
      color: @activeColor!important;
      background-color: @activeBgc;
    }
  }

  // 右边··································
  .nav-bar-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .user-login {
      display: flex;
      align-items: center;
      //登录前
      .el-link.el-link--default:hover {
        color: #24ba58;
      }

      .user-login-line {
        margin: 0 5px;
        border-left: 2px solid #222;
        height: 13px;
      }

      //登录后
      .block {
        display: flex;

        cursor: pointer;
        align-items: center;
      }

      .message {
        display: flex;
        position: relative;
        margin: 0 10px;
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/img/login/xiaoxi.png");
        background-repeat: no-repeat;
        background-size: 100%;

        cursor: pointer;
        align-items: center;
        .msg_num {
          display: inline-block;

          position: absolute;
          top: -15px;
          left: -2px;
          border-radius: 7px;
          width: 23px;
          height: 14px;
          font-family: Microsoft YaHei;
          font-size: 12px;
          font-weight: 400;
          line-height: 14px;
          text-align: center;
          color: rgba(255, 255, 255, 1);
          background: rgba(234, 104, 40, 1);
        }

        .box-card {
          position: absolute;
          top: 15px;
          right: 15px;
          z-index: 20;
          border: 0;
          width: 0;
          height: 0;

          cursor: default;
          // 设置滚动条样式··································
          .infinite-list::-webkit-scrollbar {
            /*滚动条整体样式*/
            width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
            height: 1px;
          }

          .infinite-list::-webkit-scrollbar-thumb {
            /*滚动条里面小方块*/
            border-radius: 10px;
            background: #535353;
            -webkit-box-shadow: inset 0 0 5px #24ba58;
            box-shadow: inset 0 0 5px #24ba58;
          }

          .infinite-list::-webkit-scrollbar-track {
            border-radius: 20px;
            background: #ededed;
            /*滚动条里面轨道*/

            -webkit-box-shadow: inset 0 0 5px #fff;
            box-shadow: inset 0 0 5px #fff;
          }

          // 设置滚动条样式··································

          .infinite-list {
            overflow: auto;

            height: 200px;
            .infinite-list-item {
              margin: 10px 0;
              border-radius: 5px;
              padding: 5px 5px;

              background-color: #f4f4f5;
              transition: all 0.2s linear;
              cursor: pointer;
            }

            .infinite-list-item:hover {
              box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
            }
          }
        }
      }

      .message:hover {
        background-image: url("~@/assets/img/login/xuanzhong.png");

        .box-card {
          border: 1px solid #ebeef5;
          width: 329px;
          height: 300px;
        }
      }

      .exitLogin {
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/img/login/tuichu.png");
        background-repeat: no-repeat;
        background-size: 100%;

        cursor: pointer;
      }

      .exitLogin:hover {
        width: 20px;
        height: 20px;
        background-image: url("~@/assets/img/login/zuanzhong.png");
        background-repeat: no-repeat;
        background-size: 100%;
      }
    }
  }
}
</style>